export const versionData = {
  version: '1.3.40',
};
